import React from "react";
import { useSelector } from "react-redux";
import { CMS_DESCRIPTION_TEXTS } from "../../../data/cms-description-text";
import { COMPONENT_MODES } from "../../../data/constants";
import { RootState } from "../../../redux/store";
import DescriptionText from "../../../components/reusable-ui/description-text";

interface Props {
  data?: any;
  modeConfig?: any;
  setModeConfig?: any;
}

const ChannelsDetailsEditView = (props: Props) => {
  const { data, modeConfig, setModeConfig } = props;
  const allChannelsDefDataMap = useSelector(
    (state: RootState) => state.businessReducer?.allChannelsDefDataMap
  );
  const businessBranchesDataMap = useSelector(
    (state: RootState) => state.businessReducer?.businessBranchesDataMap
  );

  return (
    <section className="w-[100%] bg-white p-[24px]">
      <div className="flex items-center justify-between mb-10">
        <p className="text-[20px] font-medium">Channels</p>
        <div
          className="flex cursor-pointer"
          onClick={() =>
            setModeConfig({ ...modeConfig, type: COMPONENT_MODES.editMode })
          }
        >
          <div className="rista-sprite ic-pencil-blue"></div>
          <p className="text-14 text-blue font-semibold ml-4">Edit</p>
        </div>
      </div>
      <DescriptionText
        descriptionText={CMS_DESCRIPTION_TEXTS.chargeView.channel}
        customClass="text-[13px] text-black/40 mb-[40px]"
      />
      <div className="border border-[#F5F5F5] mt-[24px]">
        <div className="flex items-center justify-between bg-[#FAFAFA]">
          <div className="text-[#7C7C7C] text-[14px] w-1/2 font-semibold px-[20px] py-[16px] border-r border-[#F5F5F5]">
            Channel
          </div>
          <div className="text-[#7C7C7C] text-[14px] w-1/2 font-semibold px-[20px] py-[16px]">
            Branch
          </div>
        </div>

        {data?.channelInfoList?.length > 0 &&
          data?.channelInfoList?.map((channelInfo: any, index: number) => {
            return (
              <div
                key={index}
                className="flex border-b border-[#F5F5F5] last:border-none"
              >
                {channelInfo?.channelDefIds?.length > 0 ? (
                  <div className="flex items-center px-[20px] py-[16px] border-r border-[#F5F5F5] w-1/2 text-[15px] font-normal">
                    {allChannelsDefDataMap[channelInfo?.channelDefIds[0]]?.name}
                  </div>
                ) : null}

                <div className="w-1/2 pl-[4px]">
                  {channelInfo?.branchIds?.length > 0
                    ? channelInfo?.branchIds?.map(
                        (branchId: string, index: any) => {
                          return (
                            <div
                              key={index}
                              className=" text-[15px] font-normal border-b border-[#F5F5F5] last:border-none p-[16px] pr-[20px]"
                            >
                              {businessBranchesDataMap[branchId]?.branchName}
                            </div>
                          );
                        }
                      )
                    : businessBranchesDataMap &&
                      Object.values(businessBranchesDataMap)?.map(
                        (branchObj: any, index: number) => {
                          return (
                            <div
                              key={index}
                              className=" text-[15px] font-normal border-b border-[#F5F5F5] last:border-none p-[16px] pr-[20px]"
                            >
                              {branchObj?.branchName}
                            </div>
                          );
                        }
                      )}
                </div>
              </div>
            );
          })}
      </div>
    </section>
  );
};

export default ChannelsDetailsEditView;
